<script setup lang="ts">
const { loadLayout, layoutData } = useLayout()
await loadLayout()
const isOpen = ref(false)

const toggleMenu = () => {
  if (isOpen.value) {
    closeMenu()
  }
  else {
    openMenu()
  }
}

const openMenu = () => {
  isOpen.value = true
}

const closeMenu = () => {
  isOpen.value = false
}

const handleKeyPress = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('keyup', handleKeyPress)
})

onBeforeUnmount(() => {
  document.removeEventListener('keyup', handleKeyPress)
})

const sublinks = useTemplateRef<HTMLElement>('sublinks')
onClickOutside(sublinks, () => closeMenu())
</script>

<template>
  <div class="top-links">
    <div
      v-if="isOpen"
      class="top-links__backdrop backdrop"
      @click="closeMenu"
    />

    <ul
      v-if="layoutData?.serviceLinks?.[0]?.Links?.length"
      class="top-links__list"
    >
      <li
        v-if="layoutData?.aboutUs?.[0]?.Links?.length"
        ref="sublinks"
        class="top-links__item"
      >
        <button
          id="top-links__button"
          type="button"
          class="top-links__link"
          :aria-expanded="isOpen ? 'true' : 'false'"
          aria-haspopup="true"
          aria-controls="top-links__panel"
          @click="toggleMenu"
        >
          <span>{{ layoutData?.aboutUs?.[0]?.Title }}</span>

          <Icon
            name="icon:chevron"
            class="top-links__icon"
            :class="{ 'top-links__icon--open': isOpen }"
          />
        </button>

        <ul
          id="top-links__panel"
          class="top-links__panel"
          role="menu"
          aria-labelledby="top-links__button"
        >
          <li
            v-for="item in layoutData?.aboutUs[0].Links"
            :key="item.id"
          >
            <NuxtLink
              :to="item.Link"
              role="menuitem"
              class="top-links__link"
            >{{ item.Name }}</NuxtLink>
          </li>
        </ul>
      </li>
      <li
        v-for="item in layoutData?.serviceLinks?.[0]?.Links || []"
        :key="item.id"
        class="top-links__item"
      >
        <NuxtLink
          :to="item.Link"
          class="top-links__link"
        >{{ item.Name }}</NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/app/components/App/TopLinks.css");
</style>
